import { Controller } from "@hotwired/stimulus";

// Accessible disclosure: a button that shows and hides a related element, used
// for the account menu, the language picker and the admin sidebar. The contents
// are real links, so they still work with JavaScript disabled.
export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside);
  }

  toggle(event) {
    event.stopPropagation();
    this.isOpen ? this.hide() : this.show();
  }

  show() {
    this.menuTarget.classList.remove("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.closeOnOutside);
  }

  hide() {
    this.menuTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.closeOnOutside);
  }

  keydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.hide();
      this.buttonTarget.focus();
    }
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  get isOpen() {
    return !this.menuTarget.classList.contains("hidden");
  }
}
